import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

function Login({ setUsuario }) {
  const [credenciales, setCredenciales] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setCargando(true);

    try {
      const response = await fetch('/api/usuarios/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: credenciales.email,
          password: credenciales.password
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || 'Credenciales inválidas');
      }

      const data = await response.json();
      
      // Verificar que el usuario esté activo
      if (data.usuario && !data.usuario.activo) {
        throw new Error('Usuario inactivo. Contacta al administrador.');
      }

      if (data.usuario) {
        setUsuario(data.usuario);
        navigate('/');
      } else {
        throw new Error('Error al iniciar sesión');
      }
    } catch (err) {
      console.error('Error de login:', err);
      setError(err.message || 'Email o contraseña incorrectos');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="logo-container">
        <img src="/logo.png" alt="Logo" className="logo-pulse" />
      </div>
      <form onSubmit={handleLogin} className="login-box">
        <h2>Safety Point</h2>
        <input
          type="email"
          placeholder="Email"
          value={credenciales.email}
          onChange={(e) => setCredenciales({ ...credenciales, email: e.target.value })}
          required
          disabled={cargando}
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={credenciales.password}
          onChange={(e) => setCredenciales({ ...credenciales, password: e.target.value })}
          required
          disabled={cargando}
        />
        <button type="submit" disabled={cargando}>
          {cargando ? 'Ingresando...' : 'Ingresar'}
        </button>
        {error && <p className="error">{error}</p>}
       
      </form>
    </div>
  );
}

export default Login;
